import { useRef, useContext, useState, useEffect } from 'react';

import styles from './AddModeratorPopup.module.css'

import { GlobalContext } from "../../../contexts/globalContext";
import { ProjectDetailsContext } from '../../../contexts/projectDetailsContext';
import { AddConferenceContext } from '../../../contexts/addConferenceContext';

import New_InputTextComponent from '../../keyboard/New_InputTextComponent';
import ClosePageButtonComponent from '../../commons/ClosePageButtonComponent'
import InitialsCircleComponent from '../../commons/InitialsCircleComponent';

import { GetMaxZIndex } from '../../../utils/UtilitaryFunctions';

const AddModeratorPopup = () => {

    const ref = useRef()
    const inputRef = useRef()
    const usersRef = useRef()
    const filteredUsersRef = useRef()

    const [selectedFilter, setSelectedFilter] = useState("All")
    const [filteredUsers, setFilteredUsers] = useState([])

    const { language, socketRef, keyboardRef } = useContext(GlobalContext);
    const { editConference } = useContext(ProjectDetailsContext)
    const { setAddModerator, setSelectedModerator } = useContext(AddConferenceContext);


    const filterOptions = [ "All", "Member", "Guest", "Partner" ]

    useEffect(() => {
        ref.current.focus();

        socketRef.current.emit('CONFERENCE_GET_USERS_FROM_CONFERENCE', editConference._id, callback => {
            usersRef.current = callback.response
            setFilteredUsers(callback.response)
        })
    }, [])

    const handleChangeRole = (change) => {
        setSelectedFilter(change)

        let result = usersRef.current.filter(user => user.participant.role.includes(change));

        if (change === "MEMBER") {
            let adminDocs = usersRef.current.filter(user => user.participant.role.toLowerCase().includes("administrator"));
            result = [...result, ...adminDocs];
        }

        if (change === 'ALL') {
            result = usersRef.current
        }

        inputRef.current.value = ""
        setFilteredUsers(result);
        filteredUsersRef.current = result
    }

    function onTextChanged() {
        let result = []
        if (inputRef.current.value) {
            result = usersRef.current.filter(usr =>
                usr.participant.name.toLowerCase().includes(inputRef.current.value.toLowerCase())
            );
        } else {
            result = usersRef.current;
        }
        setFilteredUsers(result);
    }


    return (
        <div ref={ref} className={styles.moderatorBox} style={{ zIndex: GetMaxZIndex() + 1 }} tabIndex="0" onBlur={() =>  {
                setAddModerator(false) 
            }}>

            <ClosePageButtonComponent setClose={() => setAddModerator(false)} />
            Select moderator
            <div className={styles.participantsFilterSearch} >
                <div className={styles.filter}>
                    {filterOptions.map((option, index) => <div key={index} className={selectedFilter === option ? styles.selectedTag : styles.tag} onClick={() => handleChangeRole(option.toUpperCase())}>
                        {option.toUpperCase() !== "ALL" ? `${option}s` : option}
                    </div>)}
                </div>
                <New_InputTextComponent ref={inputRef} fontSize="30" height='80px' width="835px" marginLeft="0px" marginTop="50px" marginBottom="30px" keyboardRef={keyboardRef} value="" 
                    styleType='SEARCHPOPUP' placeHolder={language.add_participants.Search} onChange={onTextChanged} />

            </div>
            <div className={styles.participantsListAndAdd}>
                <div className={styles.participantsList}>
                    {filteredUsers?.map((attachedParticipant) => <div key={attachedParticipant._id} className={styles.participantCard} onClick={() => {
                        setSelectedModerator(attachedParticipant.participant)
                        setAddModerator(false)
                    }}>
                        <InitialsCircleComponent name={attachedParticipant.participant.name} style={{ marginLeft: 25, height: 121, width: 121, border: "6px solid #0D0032", marginBottom: 10 }} />
                        <div className={styles.participantDetails}>
                            {attachedParticipant.participant.role}
                            <div className={styles.participantName}>{attachedParticipant.participant.name}</div>
                            {attachedParticipant.participant.function?.name} {attachedParticipant.function ? "|" : ""} {attachedParticipant.participant.department?.name}
                        </div>
                    </div>)}

                </div>
                <div className={styles.participantListShadowTop} style={{ zIndex: GetMaxZIndex() + 1 }} />
                <div className={styles.participantListShadowBottom} style={{ zIndex: GetMaxZIndex() + 1 }} />
            </div>
        </div>
    );

}

export default AddModeratorPopup;